import { Form, Input, Modal, Upload, Image, message, Spin, Button, Col, Space, Divider } from 'antd'
import React, { useEffect, useState } from 'react'
import { handleShowTYPE } from '../hook/function'
import { InboxOutlined, FilePdfOutlined, SaveOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons"
import dayjs from 'dayjs';
import axios from 'axios';
import Compressor from 'compressorjs';
import { baseUrlAREA, baseUrlUPLOADIMAGELAWYER, GET_GATHER_IMAGE, HEADERS_BASIC, HEADERS_UPIMAGE, LOAD_GATHER_IMAGE, UPDATE_STATUS_THAI_POST, UPLOAD_GATHER_IMAGE } from '../../../API/apiUrlsGarfe';
import DeleteImage from './DeleteImage';

const { Dragger } = Upload;

function UploadIMGPOST({ open, close, data, setData }) {
    const [form] = Form.useForm();
    const [allImg, setAllImg] = useState([]);
    const [postData, setPostData] = useState({});
    const [loading, setLoading] = useState(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);

    const [imageData, setImageData] = useState([]);
    const [isModalDeleteImage, setIsModalDeleteImage] = useState(false);

    const token = localStorage.getItem('TOKEN');

    useEffect(() => {
        form.setFieldsValue({
            parcelNo: data?.parcelNo ? data?.parcelNo : null,
            parcelNoResponse: data?.parcelNoResponse ? data?.parcelNoResponse : null,
            // statusPost: data.statusPost ? data.statusPost : null
        })
        setPostData({
            parcelNo: data?.parcelNo ? data?.parcelNo : null,
            parcelNoResponse: data?.parcelNoResponse ? data?.parcelNoResponse : null,
            // statusPost: data.statusPost ? data.statusPost : null
        })
        loadImage()
    }, [])

    const handleClose = () => {
        setData()
        close(false)
    }

    // const onChangeRadio = (e) => {
    //     setPostData({ ...postData, statusPost: e.target.value })
    // }

    const getBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });

    const handlePreview = async file => {
        // เช็คว่าเป็น PDF หรือไม่
        if (file.type === 'application/pdf' || file.name.endsWith('.pdf')) {
            // สร้าง Blob URL เพื่อเปิด PDF ใน tab ใหม่
            let pdfUrl = file.url;
            if (!pdfUrl && file.originFileObj) {
                pdfUrl = URL.createObjectURL(file.originFileObj);
            }
            window.open(pdfUrl, '_blank');
            return;
        }

        // ถ้าเป็นรูปภาพ ก็ใช้ Logic เดิม
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleChangeIMG = ({ fileList: newFileList, file }) => {
        const updatedFileList = newFileList.map(f => {
            if (f.type === 'application/pdf' || f.name.endsWith('.pdf')) {
                // ส่วนนี้ใส่ Logic Custom Icon ได้ถ้าต้องการ
            }
            return f;
        });

        setFileList(updatedFileList);

        if (file.status === 'removed') {
            setAllImg(prevAllImg => {
                return prevAllImg.filter(img => {
                    return img.originalIndex !== file.uid;
                });
            });
        }

        // --- 3. ปิด Loading เมื่อทำงานเสร็จ (ไม่ว่าจะ Upload เสร็จ, ลบ, หรือ Error) ---
        if (file.status === 'done' || file.status === 'removed' || file.status === 'error') {
            setLoading(false);
        }
    }
    const compressImage = async (file, types, index) => {
        return new Promise((resolve) => {

            // --- เริ่ม Logic คำนวณ Quality ---
            let quality;
            if (file.size >= 2500000) quality = 0.1;       // 2.5MB - 5MB
            else if (file.size >= 2000000) quality = 0.15; // 2.0MB - 2.49MB
            else if (file.size >= 1500000) quality = 0.2;  // 1.5MB - 1.99MB
            else if (file.size >= 1000000) quality = 0.3;  // 1.0MB - 1.49MB
            else quality = 0.5;                          // < 1.0MB

            // --- ใช้ CompressorJS ---
            new Compressor(file, {
                quality: quality,
                success: (result) => {
                    // แปลง Blob กลับเป็น File Object (เพื่อให้หน้าบ้านเอาไปใช้ง่ายๆ)
                    const fileOptions = {
                        type: result.type,
                        lastModified: Date.now(),
                    };
                    const compressedFileAsFile = new File([result], file.name, fileOptions);

                    const image = {
                        imageCompressedFile: compressedFileAsFile,
                        type: types,
                        originalIndex: index
                    };

                    // บันทึก state
                    setAllImg(prev => [...prev, image]);
                    setLoading(false);
                    resolve(true);
                },
                error: (err) => {
                    console.error('Compressor error:', err);
                    message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้ กรุณาลองใหม่`);
                    setLoading(false);
                    resolve(true);
                },
            });
        });
    };

    const beforeUpts = async (file, ty) => {
        const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

        if (isPdf) {
            // สร้าง Object เตรียมเก็บ
            const image = {
                imageCompressedFile: file, // ใช้ไฟล์ต้นฉบับเลย
                type: ty,
                originalIndex: file.uid
            };

            // บันทึกลง State เลย ไม่ต้องไป compressImage
            setAllImg(prev => [...prev, image]);

            return false; // หยุด Auto Upload ของ AntD
        }
        if (file.size > 5000000) {
            message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
            return Upload.LIST_IGNORE;
        }

        try {
            setLoading(true)
            await compressImage(file, ty, file.uid);
            return false;
        } catch (error) {
            console.error('File processing error:', error);
            message.error('File processing failed.');
            return Upload.LIST_IGNORE;
        }
    }

    const loadImage = () => {
        axios.get(baseUrlUPLOADIMAGELAWYER + LOAD_GATHER_IMAGE + `/${data.typeReply}/${data.id}`, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data?.length > 0) {
                        setImageData(res.data)
                    } else {
                        message.warning("ไม่พบรูปภาพ");
                    }
                }
            })
            .catch(err => {
                message.error("เกิดข้อผิดพลาดในการโหลดรูปภาพ");
                console.error("err", err)
            })
            .finally(() => setLoading(false));


    }
    const handleSave = () => {
        if (allImg.length > 0) {
            handleUpLoadIMG(allImg)
        } else {
            handleUpdate(null)
        }
    }

    const handleUpdate = (value) => {

        let sendData
        if (value === "deleteAll") {
            sendData = {
                ...data,
                ...postData,
                typeStatus: "status_post",
                statusPost: null,
                menuType: data?.typeReply
            };
        } else {
            sendData = {
                ...data,
                ...postData,
                typeStatus: "status_post",
                statusPost: imageData.length > 0 || allImg.length > 0 ? 1 : null,
                menuType: data?.typeReply
            };
        }

        console.log("sendData", sendData)

        axios.post(baseUrlAREA + UPDATE_STATUS_THAI_POST, sendData, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    message.success("บันทึกข้อมูลสำเร็จ");
                    setAllImg([])
                    setFileList([])
                    // setTimeout(() => {
                    //     handleClose()
                    // }, 1000);
                }
            })
            .catch(err => {
                message.error("บันทึกข้อมูลไม่สำเร็จ");
                console.error("err", err)
            })
            .finally(() => setLoading(false));
    }

    const handleUpLoadIMG = (resultImgs) => {
        setLoading(true)
        const newFormData = new FormData();
        return new Promise(async (resolve, reject) => {
            try {
                var status;
                newFormData.append('id', data.id);
                newFormData.append('notis', data.typeReply);
                // newFormData.append('tm', dayjs().format("YYYY-MM-DDTHH:mm:ssZ"));

                // ⭐ เรียงตาม originalIndex ก่อน
                const sortedImgs = resultImgs
                    .filter(img => img.originalIndex !== undefined)
                    .sort((a, b) => {
                        // Primary sort: type
                        const typeDiff = a.type - b.type;
                        if (typeDiff !== 0) {
                            return typeDiff;
                        }

                        // Secondary sort: originalIndex (เมื่อ type เท่ากัน)
                        return a.originalIndex - b.originalIndex;
                    });

                for (const file of sortedImgs) {
                    var image = {}
                    newFormData.append('file', file.imageCompressedFile);
                    newFormData.append("menuType", data.typeReply);
                    newFormData.append("imageType", file.type);
                    image.type = file.type
                }
                const response = await axios.post(baseUrlUPLOADIMAGELAWYER + UPLOAD_GATHER_IMAGE, newFormData, { headers: HEADERS_UPIMAGE });
                if (response.status === 200) {
                    message.success("บันทึกรูปสำเร็จ");
                    status = response.status;
                    resolve(status);
                    loadImage()
                    handleUpdate()
                }
            } catch (error) {
                reject(error);
                message.error("บันทึกรูปไม่สำเร็จ");
            } finally {
                setLoading(false);
            }
        });
    }

    const uploadProps = {
        name: 'file',
        multiple: true,
        // เพิ่ม application/pdf
        accept: "image/*,.pdf",
        listType: "picture",
        fileList: fileList,
        onPreview: handlePreview,
        onChange: handleChangeIMG,
        beforeUpload: (file) => beforeUpts(file, 1), // บอกกล่าวเป็น 1
        // Custom Icon สำหรับไฟล์ PDF ในรายการ (ถ้าต้องการ)
        iconRender: (file) => {
            if (file.type === 'application/pdf' || file.name.endsWith('.pdf')) {
                return <FilePdfOutlined style={{ fontSize: '48px', color: '#ff4d4f' }} />;
            }
            return null; // ใช้ Default ของ AntD สำหรับรูปภาพ
        },
        onDrop(e) {
            // console.log('Dropped files', e.dataTransfer.files);
        },
    };

    return (
        <Modal open={open} title="อัปโหลดข้อมูลจากเว็บไปรษณีย์" width={700} footer={[null]} closable={false}>
            <Spin spinning={loading} size="large" tip=" Loading... ">
                <Form
                    form={form}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    onFinish={handleSave}
                >
                    <Form.Item label="เลขสัญญา" style={{ marginBottom: 8 }}>{data?.CONTNO}</Form.Item>
                    <Form.Item label="ประเภทสัญญา" style={{ marginBottom: 8 }}>{handleShowTYPE(data?.contractSchema)}</Form.Item>
                    <Form.Item label="วันที่ออกหนังสือ" style={{ marginBottom: 8 }}>{data?.roundDate ? dayjs(data?.roundDate).format("DD-MM-YYYY") : "-"}</Form.Item>
                    {/* <Form.Item label="ผู้ทำสัญญา" style={{ marginBottom: 8 }}>{data?.customerFullName} คนค้ำที่ ({data?.customerTypeId})</Form.Item> */}
                    <Form.Item label="ผู้ทำสัญญา" style={{ marginBottom: 8 }}>
                        {data?.customerFullName} {data?.typeReply === 1 ? `(คนค้ำ${data?.customerTypeId})` :
                            data?.typeReply === 2 && data?.customerTypeId === 0 ? "(ผู้เช่าซื้อ)" :
                                data?.typeReply === 2 && data?.customerTypeId !== 0 ? `(คนค้ำ${data?.customerTypeId})` :
                                    data?.typeReply === 3 && data?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                                        data?.typeReply === 3 && data?.customerTypeId !== 0 ? `(คนค้ำ${data?.customerTypeId})` :
                                            data?.typeReply === 4 && data?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                                                data?.typeReply === 4 && data?.customerTypeId !== 0 ? `(คนค้ำ${data?.customerTypeId})` :
                                                    "-"}
                    </Form.Item>
                    <Form.Item label="EMS จดหมาย" name="parcelNo" rules={[{ required: true, message: "กรุณาใส่ EMS จดหมาย !" }]}>
                        <Input onChange={(e) => setPostData({ ...postData, parcelNo: e.target.value })} />
                    </Form.Item>

                    <Form.Item label="EMS ใบตอบกลับ" name="parcelNoResponse" rules={[{ required: true, message: "กรุณาใส่ EMS ใบตอบกลับ !" }]}>
                        <Input onChange={(e) => setPostData({ ...postData, parcelNoResponse: e.target.value })} />
                    </Form.Item>

                    {/* <Form.Item label="การตอบกลับ" name="statusPost" rules={[{ required: true, message: "กรุณาใส่ การตอบกลับ !" }]}>
                        <Radio.Group
                            onChange={onChangeRadio}
                            // defaultValue={1}
                            options={[{ value: 1, label: 'สำเร็จ' }, { value: 2, label: 'ตีกลับ' }]}

                        />
                    </Form.Item> */}

                    <Form.Item label="อัปโหลดไฟล์">
                        <Dragger {...uploadProps} style={{ padding: '20px' }}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined style={{ color: '#1890ff' }} />
                            </p>
                            <p className="ant-upload-text">คลิกหรือลากไฟล์มาวางที่นี่เพื่ออัปโหลด</p>
                            <p className="ant-upload-hint">
                                รองรับไฟล์รูปภาพ (jpg, png) และ PDF ขนาดไม่เกิน 5MB
                            </p>
                        </Dragger>
                    </Form.Item>
                    {
                        imageData.length > 0 ?
                            <>
                                <Divider />
                                <Form.Item label="รูปภาพ">
                                    <div style={{ flexWrap: 'wrap', justifyContent: 'center', gap: '1px' }}>
                                        {imageData?.map((e, index) => {
                                            return (
                                                <div key={index} style={{ position: 'relative', display: 'inline-block', margin: 5 }}>
                                                    <Image
                                                        width={150}
                                                        height={150}
                                                        key={index}
                                                        src={`${GET_GATHER_IMAGE}/${e.path}?token=${token}`}
                                                        alt={`รูปภาพ ${index + 1}`}
                                                        style={{ display: 'block', borderRadius: '8px' }}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <Button type='primary' danger onClick={() => setIsModalDeleteImage(true)} icon={<DeleteOutlined />}>ลบรูป</Button>
                                </Form.Item>
                            </>
                            :
                            null
                    }
                    <Col style={{ textAlign: 'end' }}>
                        <Space>
                            <Button type="primary" style={{ backgroundColor: 'gray' }} icon={<CloseOutlined />} onClick={handleClose}>ปิด</Button>
                            <Button type="primary" htmlType='submit' icon={<SaveOutlined />} style={{ backgroundColor: 'green' }}>บันทึก</Button>
                        </Space>
                    </Col>
                </Form>
                {previewImage && (
                    <Image
                        wrapperStyle={{ display: 'none' }}
                        preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) => setPreviewOpen(visible),
                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                        }}
                        src={previewImage}
                    />
                )}
            </Spin>
            {
                isModalDeleteImage ?
                    <DeleteImage
                        open={isModalDeleteImage}
                        close={setIsModalDeleteImage}
                        data={imageData}
                        setData={setImageData}
                        handleUpdate={handleUpdate}
                    />
                    : null

            }
        </Modal >
    )
}

export default UploadIMGPOST